import { IconLayoutSidebar } from '@tabler/icons-react';
import { DrawerProps as MUIDrawerProps } from '@mui/material/Drawer';
import { useLocation } from 'react-router-dom';

import Link from '../../Link';
import MenuList from '../MenuList';
import { getFooterMenuOptions, getMenuSections } from '../menu';
import ProfileMenu from '../ProfileMenu';

import {
  FooterDivider,
  GradientEmphasis,
  ScrollableContainer,
  StyledDrawer,
  Title,
  TitleToolbar,
  ToggleButton,
} from './index.styles';

interface MenuProps {
  userGroups: string[];
  expanded: boolean;
}

const Menu = ({ userGroups, expanded }: MenuProps) => {
  const { pathname } = useLocation();

  return (
    <>
      {getMenuSections(userGroups).map((section, index) => (
        <MenuList
          key={section.header ?? `section-${index}`}
          header={section.header}
          source={section.items}
          currentPath={pathname}
          expanded={expanded}
          separated={index > 0}
        />
      ))}
    </>
  );
};

interface DrawerProps extends MUIDrawerProps {
  onToggle?: () => void;
  expanded?: boolean;
  userGroups?: string[];
}

const Drawer = ({
  expanded = true,
  onToggle = () => {},
  userGroups = [],
  ...rest
}: DrawerProps) => {
  const { pathname } = useLocation();

  const footerOptions = getFooterMenuOptions(userGroups);

  return (
    <StyledDrawer
      SlideProps={{
        appear: false,
      }}
      variant='persistent'
      $expanded={expanded}
      $isSm
      {...rest}
    >
      <TitleToolbar $expanded={expanded}>
        <Title variant='h6' $expanded={expanded}>
          <Link href='/' underline='none' color='inherit'>
            <GradientEmphasis>Cognito</GradientEmphasis> Online
          </Link>
        </Title>
        <ToggleButton
          size='medium'
          disableRipple
          aria-label='toggle sidebar'
          title={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
          onClick={onToggle}
        >
          <IconLayoutSidebar />
        </ToggleButton>
      </TitleToolbar>
      <ScrollableContainer>
        <Menu userGroups={userGroups} expanded={expanded} />
      </ScrollableContainer>
      {footerOptions.length > 0 && (
        <>
          <FooterDivider />
          {/* The pinned entry is an ordinary drawer item, so it highlights
              through the same isInPaths mechanism as the nav items. */}
          <MenuList expanded={expanded} currentPath={pathname} source={footerOptions} />
        </>
      )}
      <ProfileMenu expanded={expanded} />
    </StyledDrawer>
  );
};

export default Drawer;
